var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-skeleton-loader',{attrs:{"type":"article"}}),_c('v-skeleton-loader',{attrs:{"type":"actions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }